"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSignatures = void 0;
const debug_1 = __importDefault(require("debug"));
const debug = (0, debug_1.default)("decoder:fetch-signatures");
const axios_1 = __importDefault(require("axios"));
const async_retry_1 = __importDefault(require("async-retry"));
const codec_1 = require("@truffle/codec");
function fetchSignatures(selector, //note: input should be 4 bytes long
url) {
    return __awaiter(this, void 0, void 0, function* () {
        const selectorString = codec_1.Conversion.toHexString(selector);
        let page = 1;
        let signatures = [];
        while (true) {
            const response = yield getSuccessfulResponse(selectorString, url, page);
            signatures = signatures.concat(response.results.map(({ text_signature }) => text_signature)); //append new signatures
            if (response.next === null) {
                break;
            }
            page++; //ideally we'd use the actual value of response.next, but this is easier
        }
        return signatures;
    });
}
exports.fetchSignatures = fetchSignatures;
function getSuccessfulResponse(selector, url, page) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, async_retry_1.default)(() => __awaiter(this, void 0, void 0, function* () {
            return (yield axios_1.default.get(`${url}/v1/signatures/`, {
                params: {
                    hex_signature: selector,
                    page
                },
                responseType: "json",
                maxRedirects: 50
            })).data;
        }), { retries: 3 } //we'll leave minTimeout as the default 1000
        );
    });
}
//# sourceMappingURL=fetch-signatures.js.map